import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import Steps from "./common/Steps";

const Header = ({banner}) => {
    const location = useLocation();
    const [step, setStep] = useState(null);


    useEffect(() => {
        const pathMatch = location.pathname.match(/\/step\/(\d+)/);
        if (pathMatch) {
            setStep(parseInt(pathMatch[1]));
        }
    }, [location])


    return <div className={`container app-header`}>
        <div className="row">
            <div className="col">
                {step && <Steps step={step}/>}

                {/* Banner */}
                {banner !== null &&
                    <div id="banner-wrapper" style={{width: '100%', textAlign: 'center'}} dangerouslySetInnerHTML={{__html: banner}}/>
                }
            </div>
        </div>
    </div>
};

export default Header;